module.exports = __webpack_public_path__ + "static/img/chuanbo.026fb38d.png";